import imagesCulture from "./culture/culture";
import imagesEconomy from "./economy/economy";
import imagesOrganization from "./organization/organization";
import imagesRegulation from "./regulation/regulation";

type WebpackRequireContext = {
  keys: () => string[];
  (id: string): any;
  resolve(id: string): string;
  id: string;
};

export interface ImageMap {
  [key: string]: string;
}

export function importAll(r: WebpackRequireContext): ImageMap {
  const images: ImageMap = {};
  r.keys().forEach((key: string) => (images[key] = r(key)));
  return images;
}

const images: ImageMap = {
  ...imagesCulture,
  ...imagesEconomy,
  ...imagesRegulation,
  ...imagesOrganization,
};

export default images;

export const getImage = (value?: string) =>
  value && value.split("/").splice(1)[0].split(".").splice(0)[0];

export const getTemplateImg = (valueTemplateImage: string) => {
  const filteredImages = Object.entries(images).find(
    ([item, value], index) => getImage(item) === valueTemplateImage
  );
  if (filteredImages) return filteredImages[1];
  else return "";
};
